import { Link } from 'react-router-dom';
import { Container } from '../components/layout/Primitives';
import { Button } from '../components/ui/Button';

export default function CustomerService() {
  return (
    <div className="animate-fade-in">
      <section style={{ background: 'hsl(36, 24%, 95%)', borderBottom: '1px solid hsl(35,18%,84%)' }}>
        <Container style={{ padding: '3.5rem 1.5rem 3rem' }}>
          <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Customer Service</h1>
          <p style={{ margin: '0.9rem 0 0', opacity: 0.75 }}>Need help with an order, return, or account update?</p>
        </Container>
      </section>
      <Container style={{ padding: '2.5rem 1.5rem 4rem', maxWidth: '56rem' }}>
        <p style={{ margin: 0, opacity: 0.8, lineHeight: 1.75 }}>
          Our support team can assist with order tracking, address updates before fulfillment, returns, and sizing support.
        </p>
        <Button as={Link} to="/contact" $variant="luxe" $size="lg" style={{ marginTop: '1.5rem' }}>
          Contact Support
        </Button>
      </Container>
    </div>
  );
}
